import theme from '@vromo/ui/components/theme';

export default {
    activePartnersTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: 8,
        color: theme.darkText
    },
    activePartnersSubtitle: {
        marginTop: 0,
        fontSize: '16px',
        color: theme.darkText
    },
    checkboxLabel: {
        marginLeft: 12,
        fontWeight: 'bold',
        color: theme.darkText
    }
};
